import styled, { css } from 'styled-components';
import { Colors } from '../../../ui';
import { Skeleton } from '../../../ui/Skeleton';

const Frame = styled.div`
    display: flex;
    flex-direction: column;
    gap: .5rem;
`;

const ItemDisc = styled.div`
    display: inline-block;
    margin-left: -.125rem;
    width: 1rem;
    height: 1rem;
    border: solid .25rem #fff;
    border-radius: 50%;
    background: ${Colors.primary};
`;

const ItemLabel = styled.div`
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const ItemIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 2.25rem;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: .25rem;
    
    svg {
        width: 1.75rem;
        height: 1.75rem;
    }

    ${Skeleton} {
        width: 1.5rem;
        height: 1.5rem;
    }
`;

const Item = styled.div<{ active?: boolean, dropping?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: .5rem;
    border-radius: .25rem;
    cursor: pointer;
    user-select: none;
    font-weight: 420;
    color: ${Colors.text};
 
    &:hover {
        color: ${Colors.primary};
        ${ItemIcon} {
            background: rgba(59, 101, 239, 0.10);
        }
    }
    &:active {
        color: ${Colors.primary};
        ${ItemIcon} {
            background: rgba(59, 101, 239, 0.20);
        }
    }
    ${p => p.active && css`
        color: ${Colors.primary};
        ${ItemIcon} {
            background: rgba(59, 101, 239, 0.20);
        }
    `}

    ${p => p.dropping && css`
        background: ${Colors.primaryLight};
        color: #fff;
    `}
`;

const SubItem = styled.div<{ active?: boolean, dropping?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: .5rem;
    border-radius: .25rem;
    cursor: pointer;
    user-select: none;
    font-weight: 420;
    color: ${Colors.textLight};

    ${ItemDisc} {
        display: none;
    }
    &:hover {
        color: ${Colors.primary};
    }
    &:active {
        color: ${Colors.primary};
    }
    ${p => p.active && css`
        color: ${Colors.primary};
        ${ItemDisc} {
            display: block;
        }
    `}

    ${p => p.dropping && css`
        background: ${Colors.primaryLight};
        color: #fff;
    `}
`;

const ItemGroup = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: .5rem;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 1rem;
        bottom: 1rem;
        width: .125rem;
        background: ${Colors.borderLight};
    }
`;

export const NavMenu = Object.assign(Frame, {
    Item,
    ItemDisc,
    ItemLabel,
    ItemIcon,
    SubItem,
    ItemGroup,
});
